const ResourceExtensions = {
	images: ["png", "jpg", "jpeg", "gif"],
	diagrams: ["svg", "puml", "yaml", "mermaid", "bpmn"],
};

export default ResourceExtensions;
